'use client'
import { Link, usePathname } from '@/i18n/routing'
import { ComponentProps, FC } from 'react'

type MobileNavLinkProps = {
  href: ComponentProps<typeof Link>['href']
  title: string
  exact?: boolean
}

const MobileNavLink: FC<MobileNavLinkProps> = ({ href, title, exact = false }) => {
  const pathname = usePathname()

  // Get the path for comparison
  const linkPath = typeof href === 'string' ? href : href.pathname || '/'

  const isActive = exact ? pathname === linkPath : pathname.startsWith(linkPath)
  const mobileNavLinkClassName = 'text-lg lg:text-2xl leading-6  m-0 font-light'
  const newClassName = isActive ? `${mobileNavLinkClassName} text-accent font-medium` : `${mobileNavLinkClassName} active:border-b active:border-accent text-white`

  return (
    <li className="flex">
      <Link href={href} className={newClassName}>
        {title}
      </Link>
    </li>
  )
}

export default MobileNavLink
